module.exports = __webpack_public_path__ + "static/media/headerLogo.e083b60e.png";